import React, {useState, useEffect} from 'react';
import {useHistory, useParams} from "react-router-dom";
import {withTranslation} from 'react-i18next';
import {ProgressBar} from 'primereact/progressbar';
import {Form, Field} from 'react-final-form';
import {Button} from "primereact/button";
import {Dropdown} from "primereact/dropdown";
import {InputText} from "primereact/inputtext";
import {classNames} from "primereact/utils";
import {addLocale} from "primereact/api";
import axios from "axios";
import {AutoComplete} from "primereact/autocomplete";
import {InputMask} from "primereact/inputmask";
import moment from "moment";
import ReactQuill from "react-quill";
import {Calendar} from "primereact/calendar";
import {InputTextarea} from "primereact/inputtextarea";

const OfferFormComponent = (props) => {

  const {t} = props;
  const history = useHistory();
  const {entity, action, id} = useParams();
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    status: 'DRAFT',
    language: "hu",
    valid_until: new Date(),
    project_type: Number(window.App.urlVars().projectTypeId),
    currency: process.env.REACT_APP_CURRENCY_DEFAULT,
    name: window.App.urlVars().name ? decodeURIComponent(window.App.urlVars().name) : '',
    partner: window.App.urlVars().partnerId ? Number(window.App.urlVars().partnerId) : null
  });
  const [newFormData, setNewFormData] = useState({});
  const [partners, setPartners] = useState([]);
  const [partnerQuery, setPartnerQuery] = useState(
    window.App.urlVars().partnerName ? decodeURIComponent(window.App.urlVars().partnerName) : ''
  );
  const [partnerLoading, setPartnerLoading] = useState(false);
  const [companys, setCompanys] = useState([]);
  const [employees, setEmployees] = useState([]);
  const [currencies, setCurrencies] = useState([]);
  const [languages, setLanguages] = useState([]);
  const [partnerContacts, setPartnerContacts] = useState([]);
  const [partnerContactsLoading, setPartnerContactsLoading] = useState(false);

  const validate = (data) => {
    let errors = {};
    // if (!data.company) {
    //   errors.company = 'Kötelező mező';
    // }
    // if (!data.partner) {
    //   errors.partner = 'Kötelező mező';
    // }
    return errors;
  };
  const onSubmit = (data, form) => {
    setLoading(true)
    if ((window.App.urlVars().offerId) || (entity === 'offer' && id && id !== 'undefined')) {
      apiCall('patch', '/api/v2/offer/' + id, newFormData)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderOfferList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    } else {
      apiCall('post', '/api/v2/offer' + (window.App.urlVars().crmDealId ? '?crmDealId=' + Number(window.App.urlVars().crmDealId) : ''), data)
        .then(response => {
          window.App.toastShow('success', 'Sikeres mentés!');
          window.App.setState({rerenderOfferList: Math.random()})
          if (props.goback === true) {
            history.push(props.backlink);
          } else {
            history.push('/project/offer/read/' + response.data.data.id);
          }
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  };

  const loadPartnerContacts = (partnerId) => {
    if (!partnerId) {
      setPartnerContacts([]);
      return;
    }
    setPartnerContactsLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/contact-partner", {
      params: {
        rows: 9999,
        'search[partner][operator]': '==',
        'search[partner][value]': partnerId
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        setPartnerContacts(response?.data?.data?.items || []);
      })
      .catch(error => {
        setPartnerContacts([]);
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerContactsLoading(false);
      });
  };

  const isFormFieldValid = (meta) => !!(meta.touched && meta.error);
  const getFormErrorMessage = (meta) => {
    return isFormFieldValid(meta) && <small className="p-error">{meta.error}</small>;
  };

  addLocale('hu', {
    firstDayOfWeek: 1,
    dayNames: ['vasárnap', 'hétfő', 'kedd', 'szerda', 'csütörtök', 'péntek', 'szombat'],
    dayNamesShort: ['vas', 'hé', 'ke', 'sze', 'csü', 'pé', 'szo'],
    dayNamesMin: ['V', 'H', 'K', 'SZ', 'CS', 'P', 'SZ'],
    monthNames: ['január', 'február', 'március', 'április', 'május', 'június', 'július', 'augusztus', 'szeptember',
      'október', 'november', 'december'],
    monthNamesShort: ['jan', 'feb', 'mar', 'ápr', 'máj', 'jun', 'júl', 'aug', 'szep', 'okt', 'nov', 'dec'],
    today: 'Ma',
    clear: 'Töröl'
  });

  const toolbarOptions = {
    container: [
      [{'header': [1, 2, 3, 4, 5, 6, false]}],
      ['bold', 'italic', 'underline', 'strike'],
      ['image', 'formula'],
      [{'align': []}],

      [{'list': 'ordered'}, {'list': 'bullet'}, {'list': 'check'}],
      [{'script': 'sub'}, {'script': 'super'}],
      [{'indent': '-1'}, {'indent': '+1'}],
      [{'color': []}, {'background': []}],
      ['clean']
    ]
  }

  const apiCall = (method, url, data) => {
    return axios({
      method: method,
      url: process.env.REACT_APP_API_HOST + url,
      data,
      params: {},
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
  }

  const searchPartner = (event) => {
    const q = (event?.query || '').trim();
    setPartnerQuery(q);
    if (q.length < 2) {
      setPartners([]);
      return;
    }
    setPartnerLoading(true);
    axios.get(process.env.REACT_APP_API_HOST + "/api/v2/partner", {
      params: {
        rows: 15,
        'search[name][operator]': 'like',
        'search[name][value]': `%${q}%`,
        'search[customer][operator]': '==',
        'search[customer][value]': 'true'
      },
      headers: {
        'Authorization': 'Bearer ' + localStorage.getItem("userToken"),
        'App-Network': localStorage.getItem("networkId")
      }
    })
      .then(response => {
        const items = response?.data?.data?.items || [];
        const mapped = items.map((partner) => ({
          ...partner,
          displayName:
            partner.name +
            (
              partner.address_postal_code || partner.address_city || partner.address_detail
                ? ` (${partner.address_postal_code || ''} ${partner.address_city || ''}, ${partner.address_detail || ''})`
                : ''
            )
        }));
        setPartners(mapped);
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
      .finally(() => {
        setPartnerLoading(false);
      });
  };

  useEffect(() => {
    const partnerId = formData.partner?.id || formData.partner;
    if (partnerId) {
      loadPartnerContacts(partnerId);
    } else {
      setPartnerContacts([]);
    }
  }, [formData.partner]);

  useEffect(() => {
    const partnerId = window.App.urlVars().partnerId;
    const partnerName = window.App.urlVars().partnerName;
    if (partnerId && partnerName) {
      setFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setNewFormData(prev => ({
        ...prev,
        partner: Number(partnerId)
      }));
      setPartnerQuery(decodeURIComponent(partnerName));
    }
  }, [window.location.hash]);

  // useEffect(() => {
  //   if (formData.shortcut_dto_id) {
  //     apiCall('get', '/api/v2/offer/dto/' + formData.shortcut_dto_id)
  //       .then(response => {
  //         setItems(response.data.data.children)
  //       })
  //   }
  // }, [formData.shortcut_dto_id])

  // useEffect(() => {
  //   if (formData.status) {
  //     apiCall('get', '/api/v2/dictionary/offer-status-transitions')
  //       .then(response => {
  //         Object.entries(response.data.data).map(([key, value]) => {
  //           if (key === formData.status) {
  //             setStatuses(value)
  //           }
  //         })
  //       })
  //   }
  // }, [formData.status])

  useEffect(() => {
    apiCall('GET', '/api/v2/dictionary/currency')
      .then(response => {
        setCurrencies(response.data.data)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/language?item_per_page=200&sort=name&direction=asc')
      .then(response => setLanguages(response?.data?.data?.items || []))
      .catch(() => setLanguages([{name: 'Magyar', code: 'hu'}, {name: 'Angol', code: 'en'}]))
    let _emloyeeQuery = {
      rows: 9999
    }
    let emloyeeQuery = window.App.transformQueryParams(_emloyeeQuery)
    apiCall('get', '/api/v2/employee' + emloyeeQuery)
      .then(response => {
        setEmployees(response.data.data.items)
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    apiCall('GET', '/api/v2/company')
      .then(response => {
        setCompanys(response.data.data.items);
        if (!id && response.data?.data?.items[0]) {
          setFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }));
          setNewFormData(prev => ({
            ...prev,
            company: response.data.data.items[0].id
          }));
        }
      })
      .catch(error => {
        window.App.toastShow('error', t('error'), error.toString(), '', error.response);
      })
    if ((!window.App.urlVars().create && window.App.urlVars().offer) || (entity === 'offer' && id)) {
      setLoading(true);
      apiCall('get', '/api/v2/offer/' + (window.App.urlVars().offer ?? id))
        .then(response => {
          const data = response.data.data;
          setFormData({
            ...data,
            partner: data.partner?.id || data.partner || null,
            partner_contact: data.partner_contact?.id || data.partner_contact || null
          });
          setPartnerQuery(data.partner?.name || data.partnerName || '');
        })
        .catch(error => {
          window.App.toastShow('error', t('error'), error.toString(), '', error.response);
        })
        .finally(() => {
          setLoading(false);
        })
    }
  }, [])

   useEffect(() => {
      if (!(action === 'update') && currencies?.length && !formData.currency) {
        setFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
        setNewFormData(prev => ({ ...prev, currency: process.env.REACT_APP_CURRENCY_DEFAULT }));
      }
    }, [currencies, entity, id, formData.currency]);

  return (
    <div className={"offer-form widget"}>
      {loading &&
        <ProgressBar mode="indeterminate"
                     style={{height: '5px', position: "absolute", top: 0, left: 0, borderRadius: 0,}}></ProgressBar>
      }
      <Form onSubmit={onSubmit} initialValues={formData}
            validate={validate} render={({handleSubmit, submitting}) => (
        <form onSubmit={handleSubmit} className="">
          <div className={"p-grid"}>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="name" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="name"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldName')}</label>
                  <span className="p-d-block">
                      <InputText id="name" {...input}
                                 onChange={(e) => {
                                   setFormData({
                                     ...formData,
                                     name: e.target.value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     name: e.target.value
                                   })
                                 }}
                                 value={formData.name}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"} id="partner">
              <Field name="partner" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="partner" className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartner')}</label>
                  <span className={"p-field p-inputgroup"}>
                      <Button type="button" className={"p-button"}
                              onClick={() => {
                                const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                let _params = '?';
                                Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                  _params += key + '=' + value + '&';
                                });
                                _params += 'backlink=' + encodeURIComponent(currentPath) + '&';
                                _params += 'search=partner';
                                history.push(currentPath + _params);
                              }}>
                        <i className={"pi pi-search"}></i>
                      </Button>
                      <AutoComplete
                                    value={partnerQuery}
                                    id={"partner"}
                                    loading={partnerLoading}
                                    suggestions={partners}
                                    forceSelection
                                    completeMethod={searchPartner}
                                    field={"displayName"}
                                    delay={700}
                                    placeholder={t('typeToSearchPlaceholder')}
                                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                                    onSelect={(e) => {
                                      const p = e.value;
                                      if (!p?.id) return;
                                      setPartnerQuery(p.displayName || p.name || '');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: p.id,
                                        partner_contact: null
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: p.id,
                                        partner_contact: null
                                      }));
                                    }}
                                    onChange={(e) => {
                                      setPartnerQuery(e.value);
                                      if (!e.value || String(e.value).trim() === '') {
                                        setFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));

                                        setNewFormData(prev => ({
                                          ...prev,
                                          partner: null
                                        }));
                                      }
                                    }}
                                    onClear={() => {
                                      setPartnerQuery('');
                                      setFormData(prev => ({
                                        ...prev,
                                        partner: null,
                                        partner_contact: null
                                      }));
                                      setNewFormData(prev => ({
                                        ...prev,
                                        partner: null,
                                        partner_contact: null
                                      }));
                                    }}
                                  />
                              <Button type="button" className={"p-button"}
                                      onClick={() => {
                                        const currentPath = window.location.hash.replace('#', '').split('?')[0];
                                        let _params = '?';
                                        Object.entries(window.App.urlVars()).forEach(([key, value]) => {
                                          _params += key + '=' + value + '&';
                                        });
                                        _params += 'backlink=' + encodeURIComponent(currentPath) + '&';
                                        _params += 'create=partner';
                                        history.push(currentPath + _params);
                                      }}>
                                <i className={"pi pi-plus"}></i>
                              </Button>
                            </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="partner_contact" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="partner_contact"
                        className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldPartnerContact')}</label>
                  <span className="p-d-block">
                    <Dropdown
                      id={"partner_contact"}
                      options={window.App.sortDropdownOptions(partnerContacts, "contact.name")}
                      optionValue={"id"}
                      optionLabel={"contact.name"}
                      loading={partnerContactsLoading}
                      disabled={!formData.partner}
                      filter
                      showClear
                      emptyMessage={
                        formData.partner
                          ? t('noPartnerContact')
                          : t('selectPartnerFirst')
                      }
                      value={formData.partner_contact?.id || formData.partner_contact || null}
                      onChange={(e) => {
                        setFormData({
                          ...formData,
                          partner_contact: e.value
                        });
                        setNewFormData({
                          ...newFormData,
                          partner_contact: e.value
                        });
                      }}
                    />
                  </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="company" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCompany')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(companys, "name")}
                               id={"company"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noCompanyYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   company: e.value
                                 })
                                  setNewFormData({  
                                    ...newFormData,
                                    company: e.value
                                  })
                               }}
                               value={formData.company?.id || formData.company}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-6"}>
              <Field name="company_contact" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="company_contact"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldCompanyContact')}</label>
                  <span className="p-d-block">
                     <Dropdown options={window.App.sortDropdownOptions(employees, "name")}
                               id={"company_contact"}
                               optionValue={"id"}
                               optionLabel={"name"}
                               emptyMessage={t('noEmployeeYet')}
                               onChange={(e) => {
                                 setFormData({
                                   ...formData,
                                   company_contact: e.value
                                 })
                                 setNewFormData({
                                   ...newFormData,
                                   company_contact: e.value
                                 })
                               }}
                               filter
                               value={formData.company_contact?.id || formData.company_contact}
                     />
                    </span>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            {/*<div className={"p-col-12 p-lg-4"}>*/}
            {/*  <Field name="offer_number" render={({input, meta}) => (*/}
            {/*    <div className="p-field p-fluid">*/}
            {/*      <label htmlFor="offer_number"*/}
            {/*             className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldOfferNumber')}</label>*/}
            {/*      <span className="p-d-block">*/}
            {/*          <InputText id="offer_number" {...input}*/}
            {/*                     onChange={(e) => {*/}
            {/*                       setFormData({*/}
            {/*                         ...formData,*/}
            {/*                         offer_number: e.target.value*/}
            {/*                       })*/}
            {/*                       setNewFormData({*/}
            {/*                         ...newFormData,*/}
            {/*                         offer_number: e.target.value*/}
            {/*                       })*/}
            {/*                     }}*/}
            {/*                     value={formData.offer_number}*/}
            {/*                     className={classNames({'p-invalid': isFormFieldValid(meta)})}/>*/}
            {/*        </span>*/}
            {/*      {getFormErrorMessage(meta)}*/}
            {/*    </div>*/}
            {/*  )}/>*/}
            {/*</div>*/}
            <div className={"p-col-12 p-lg-3"}>
              <Field name="valid_until" render={({input, meta}) => (
                <span className="p-field p-fluid">
                    <label htmlFor="valid_until"
                           className={classNames({'p-error': isFormFieldValid(meta)})}>{t('columnValidity')}</label>
                    <div className="p-inputgroup calendar-icon-only">
                            <InputMask id={"valid_until"}
                                       mask={"9999-99-99"}
                                       placeholder={t('datePlaceholder')}
                                       value={moment.utc(formData.valid_until).local().format('YYYY-MM-DD')}
                                       onChange={(e) => {
                                         if (e.value.indexOf("_") === -1) {
                                           if (e.value === '') {
                                             e.value = null
                                           }
                                           setFormData({
                                             ...formData,
                                             valid_until: new Date(e.value)
                                           })
                                            setNewFormData({  
                                              ...newFormData,
                                              valid_until: moment(new Date(e.value)).format('YYYY-MM-DD')
                                            })
                                         }
                                       }}
                            />
                            <Calendar value={formData.valid_until}
                                      locale="hu"
                                      dateFormat={'yy-mm-dd'}
                                      showIcon
                                      onChange={(e) => {
                                        setFormData({
                                          ...formData,
                                          valid_until: e.value
                                        })
                                        setNewFormData({
                                          ...newFormData,
                                          valid_until: moment(e.value).format('YYYY-MM-DD')
                                        })
                                      }}/>
                    </div>
                  {getFormErrorMessage(meta)}
                  </span>
              )}/>
            </div>
              <div className={"p-col-12 p-lg-3"}>
                  <Field name="currency" render={({input, meta}) => (
                      <div className="p-field p-fluid">
                          <label htmlFor="currency"
                                 className={classNames({'p-error': isFormFieldValid(meta)})}>{props.t('fieldCurrency')}</label>
                          <span className={"p-d-block"}>
                    <Dropdown {...input}
                              onChange={(e) => {
                                  setFormData({
                                      ...formData,
                                      currency: e.target.value
                                  })
                                  setNewFormData({
                                      ...newFormData,
                                      currency: e.target.value
                                  })
                              }}
                              value={formData.currency}
                              options={window.App.sortDropdownOptions(currencies, "key")}
                              optionLabel="key"
                              optionValue="key"
                              id={"currency"}
                              emptyMessage={t('noCurrencyYet')}
                              className={classNames({'p-error': isFormFieldValid(meta)})}
                    />
                  </span>
                          {getFormErrorMessage(meta)}
                      </div>
                  )}/>
              </div>
              <div className={"p-col-12 p-lg-3"}>
                <Field name="language" render={({input, meta}) => (
                  <div className="p-field p-fluid">
                    <label htmlFor="language" className={classNames({'p-error': isFormFieldValid(meta)})}>{t('fieldLanguage')}</label>
                    <Dropdown
                      {...input}
                      id="language"
                      options={window.App.sortDropdownOptions(languages, 'name')}
                      optionLabel="name"
                      optionValue="code"
                      value={formData.language}
                      onChange={(e) => {
                        setFormData({...formData, language: e.value});
                        setNewFormData({...newFormData, language: e.value});
                      }}
                    />
                    {getFormErrorMessage(meta)}
                  </div>
                )}/>
              </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('offerTextDescription')}</label>
                      <div id={"editor-container"}>
                      <ReactQuill id="note" {...input}
                                  modules={{toolbar: toolbarOptions}}
                                  onChange={(value) => {
                                   setFormData({
                                     ...formData,
                                     note: value
                                   })
                                   setNewFormData({
                                     ...newFormData,
                                     note: value
                                   })
                                 }}
                                 value={formData.note}
                                 className={classNames({'p-invalid': isFormFieldValid(meta)})}/>
                      </div>
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
            <div className={"p-col-12 p-lg-12"}>
              <Field name="internal_note" render={({input, meta}) => (
                <div className="p-field p-fluid">
                  <label htmlFor="internal_note"
                         className={classNames({'p-error': isFormFieldValid(meta)})}>{t('offerInternalNote')}</label>
                  <InputTextarea
                    id="internal_note"
                    {...input}
                    rows={5}
                    autoResize
                    value={formData.internal_note || ''}
                    onChange={(e) => {
                      input.onChange(e);
                      setFormData({
                        ...formData,
                        internal_note: e.target.value
                      });
                      setNewFormData({
                        ...newFormData,
                        internal_note: e.target.value
                      });
                    }}
                    className={classNames({'p-invalid': isFormFieldValid(meta)})}
                  />
                  {getFormErrorMessage(meta)}
                </div>
              )}/>
            </div>
          </div>
          <div className={"p-grid p-mt-1"}>
            <div className={"p-col-12 p-lg-6 p-xl-6"}>
              {/* {id && id !== 'undefined' &&
                <SplitButton label={t(formData.status.toLowerCase())}
                             id="buttonStatus"
                             type="button"
                             loading={loading}
                             disabled={!id}
                             onClick={() => {
                               document.getElementById('buttonStatus').getElementsByClassName('p-splitbutton-menubutton')[0].click()
                             }}
                             icon="pi pi-info-circle"
                             className={"p-button-warning"}
                             model={statuses.map(status => {
                               return (
                                 {
                                   label: t(status.value.toLowerCase()),
                                   command: () => {
                                     setLoading(true);
                                     apiCall('patch', '/api/v2/offer/' + id, {
                                       status: status.value
                                     })
                                       .then(response => {
                                         window.App.toastShow('success', 'Sikeres módosítás', response.data.message);
                                         setFormData(response.data.data)
                                         setLoading(false);
                                       })
                                       .catch(error => {
                                         window.App.toastShow('error', t('error'), error.toString(), '', error.response);
                                         setLoading(false);
                                       })
                                   }
                                 }
                               )
                             })}/>
              } */}
              {/* {formData.status === 'ACCEPTED' &&
                <Button type="button" label={t('addProject')}
                        onClick={() => {
                          history.push('/project?create=project&projectTypeId=' + formData?.project_type?.id + '&formData=' + JSON.stringify({
                            new_era_offer: id,
                            partner: formData.partner?.id,
                            company: formData.company?.id,
                            deadline: formData.valid_until,
                            note: formData.note,
                            name: formData.name,
                            currency: formData.currency,

                          }))
                        }}
                        loading={loading}
                        icon={"pi pi-reply"}
                        className="p-button-info p-ml-2"/>
              } */}
            </div>
            <div className={"p-col-12 p-lg-6 p-xl-6 p-text-right p-col-align-center"}>
              {entity === 'offer' &&
                <Button type="submit" label={t('save')}
                        loading={loading}
                        icon={"pi pi-save"}
                        className="p-button-success p-ml-2"/>
              }
              <Button type="submit" label={t('saveAndBack')}
                      onClick={() => {
                        props = {...props, goback: true}
                      }}
                      loading={loading}
                      icon={"pi pi-arrow-left"}
                      className="p-button-success p-ml-2"/>
            </div>
          </div>
        </form>
      )}/>
    </div>
  )
}
export default withTranslation('common')(OfferFormComponent);
